import React from 'react'
import { useDispatch } from 'react-redux'

import { actionSetSelectedItem } from '../../store/actions'
import DefaultMapperData from '../../libs/default-mapper'

import EditMapperComponent from './edit-mapper'

const NewMapperComponent = () => {
  const dispatch = useDispatch()
  dispatch(actionSetSelectedItem(DefaultMapperData))

  return (
    <EditMapperComponent/>
  )
}

export default NewMapperComponent
